import { render, staticRenderFns } from "./EstadisticasPorEmpleado.vue?vue&type=template&id=85c095e8&"
import script from "./EstadisticasPorEmpleado.vue?vue&type=script&lang=js&"
export * from "./EstadisticasPorEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports